export const colors = {
  success: '#52c41a',
  error: '#ff4d4f',
  warning: '#faad14',
  foodfactsGreen: '#2ab673',
};
